#@import GliveBooking.Presenters.Time
#@export GliveBooking.Presenters.TimePicker

class GliveBooking.Presenters.TimePicker extends BookingV2.Presenters.Picker

  module: 'glive-booking'

  constructor: (options, templateName) ->
    BookingV2.Presenters.Picker.apply(this, arguments)
    @timePresenter = new GliveBooking.Presenters.Time(options, templateName)

  toHash: ->
    selected = @selected()
    loading = selected is true

    hash = BookingV2.Presenters.Picker.prototype.toHash.apply(this, arguments)
    hash.loading = loading
    hash.isTouch = @collection.meta('isTouch')

    unless loading
      selection = @timePresenter.modelToHash(selected) if selected
      hash.selection = selection?.time
      hash.isRange = @timePresenter.isRange()

    hash
